import { useQuery } from '@tanstack/react-query';
import { getValueBenchmark } from '../value.api';

export function useValueBenchmark(gln: string) {
  return useQuery({
    queryKey: ['value', 'benchmark', gln],
    queryFn: () => getValueBenchmark(gln),
    enabled: !!gln,
    staleTime: 15 * 60 * 1000,
  });
}
